import React from 'react';
import Icon from 'components/AppIcon';

const RARITY_CONFIG = {
  COMMON: {
    label: 'Common',
    border: 'border-border',
    text: 'text-muted-foreground',
    bg: 'bg-muted/20',
    glow: '',
  },
  RARE: {
    label: 'Rare',
    border: 'border-primary/40',
    text: 'text-primary',
    bg: 'bg-primary/5',
    glow: 'shadow-[0_0_12px_rgba(0,217,255,0.15)]',
  },
  EPIC: {
    label: 'Epic',
    border: 'border-purple-400/40',
    text: 'text-purple-400',
    bg: 'bg-purple-400/5',
    glow: 'shadow-[0_0_12px_rgba(192,132,252,0.2)]',
  },
  LEGENDARY: {
    label: 'Legendary',
    border: 'border-warning/50',
    text: 'text-warning',
    bg: 'bg-warning/5',
    glow: 'shadow-[0_0_16px_rgba(255,170,0,0.25)]',
  },
};

const TYPE_LABELS = {
  PROFILE_THEME: 'Profile Theme',
  UI_THEME: 'UI Theme',
  AVATAR_FRAME: 'Avatar Frame',
  FACTION_BANNER: 'Faction Banner',
  CHART_STYLE: 'Chart Style',
};

const CosmeticItemCard = ({ item, isOwned, isEquipped, onPurchase, onEquip, onUnequip, purchasing }) => {
  const rarity = RARITY_CONFIG?.[item?.rarity] || RARITY_CONFIG?.COMMON;

  return (
    <div
      className={`relative flex flex-col rounded-xl border ${
        rarity?.border
      } ${
        rarity?.bg
      } ${
        rarity?.glow
      } p-4 transition-all duration-200 hover:scale-[1.02] group`}
    >
      {/* Owned Badge */}
      {isOwned && (
        <div className="absolute top-2 right-2 z-10">
          <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-success/20 text-success border border-success/30">
            Owned
          </span>
        </div>
      )}
      {/* Preview Icon */}
      <div
        className={`w-14 h-14 rounded-xl flex items-center justify-center mb-3 border ${
          rarity?.border
        } bg-surface/80 group-hover:scale-110 transition-transform`}
      >
        <Icon
          name={item?.preview_icon || 'Package'}
          size={28}
          color={`var(--color-${
            item?.rarity === 'LEGENDARY' ?'warning'
              : item?.rarity === 'EPIC' ?'purple-400'
              : item?.rarity === 'RARE' ?'primary' :'muted-foreground'
          })`}
        />
      </div>
      {/* Name */}
      <p className="text-sm font-bold text-foreground mb-1 leading-tight">{item?.cosmetic_name}</p>
      {/* Description */}
      <p className="text-xs text-muted-foreground mb-3 leading-relaxed flex-1">{item?.description}</p>
      {/* Type + Rarity */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs px-2 py-0.5 rounded-md bg-surface border border-border text-muted-foreground">
          {TYPE_LABELS?.[item?.skin_type] || item?.skin_type}
        </span>
        <span className={`text-xs font-semibold px-2 py-0.5 rounded-md border ${rarity?.border} ${rarity?.text}`}>
          {rarity?.label}
        </span>
      </div>
      {/* Price + Action */}
      {isOwned ? (
        <button
          onClick={() => (isEquipped ? onUnequip?.(item?.id) : onEquip?.(item?.id))}
          disabled={purchasing === item?.id}
          className={`w-full py-2 rounded-lg text-xs font-semibold transition-all flex items-center justify-center gap-1.5 ${
            isEquipped
              ? 'bg-success/20 text-success border border-success/30 hover:bg-success/30' :'bg-primary/10 text-primary border border-primary/20 hover:bg-primary hover:text-zinc-950'
          }`}
        >
          <Icon name={isEquipped ? 'CheckCircle' : 'Shirt'} size={12} />
          {isEquipped ? 'Equipped — Unequip' : 'Equip'}
        </button>
      ) : (
        <button
          onClick={() => onPurchase?.(item?.id, item?.price)}
          disabled={purchasing === item?.id}
          className="w-full py-2 rounded-lg bg-primary/10 text-primary border border-primary/20 text-xs font-semibold hover:bg-primary hover:text-zinc-950 transition-all flex items-center justify-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {purchasing === item?.id ? (
            <>
              <Icon name="Loader2" size={12} className="animate-spin" />
              Purchasing...
            </>
          ) : (
            <>
              <Icon name="Coins" size={12} />
              {item?.price?.toLocaleString()}
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default CosmeticItemCard;
